<div id="wrapper">
  <div class="main-wrapper">
    <div class="internal-wrapper-1">
      <div class="internal-wrapper-2">
        <div class="dummyheader">
          Content
          <button type="button" class="close" (click)="onNoClick()" aria-hidden="true">×</button>
        </div>
        <div id="gameHistory" class="html-preview-scroll"></div>
        <div class="html-preview-scroll">
          <div [innerHTML]="transform()" class="html-preview-content" runScripts externalLink></div>
        </div>
      </div>
    </div>
  </div>
</div>
